import React, {} from 'react'
import Header from './AuthPage/Header'





function TeamInvitationWrapper(props) {
  const {children} = props
  return (
    React.createElement('div', { className: "flex min-h-screen  max-w-full flex-col items-center bg-slate-200 text-slate-700"       ,}
      , React.createElement(Header, null )
      , React.createElement('div', { className: "maxw-full flex w-full flex-1 flex-col items-center py-8 px-4"       ,}, children)
    )
  )
}

export default TeamInvitationWrapper
